import { type Layout } from 'react-grid-layout';

import { type LayoutGridCell } from './LayoutBuilder.interface';

export const calculateOccupiedCells = (
  layout: Layout[],
  cols: number,
  rows: number,
): boolean[][] => {
  const occupied: boolean[][] = Array.from({ length: rows }, () =>
    Array(cols).fill(false),
  );

  for (const item of layout) {
    for (let x = 0; x < item.w; x++) {
      for (let y = 0; y < item.h; y++) {
        const row = item.y + y;
        const col = item.x + x;

        if (row >= 0 && row < rows && col >= 0 && col < cols) {
          occupied[row][col] = true;
        }
      }
    }
  }

  return occupied;
};

export const calculateIsGridFull = (
  layout: Layout[],
  cols: number,
  rows: number,
): boolean => {
  const totalCells = cols * rows;
  let occupiedCount = 0;

  for (const item of layout) {
    occupiedCount += item.w * item.h;
    if (occupiedCount >= totalCells) {
      return true; // Exit early when the grid is full
    }
  }

  return occupiedCount >= totalCells;
};

export const getHighlightedCells = (
  startPos: LayoutGridCell | null,
  col: number,
  row: number,
): LayoutGridCell[] => {
  if (!startPos) return [];

  const newHighlightedCells: LayoutGridCell[] = [];
  const minX = Math.min(startPos.col, col);
  const minY = Math.min(startPos.row, row);
  const maxX = Math.max(startPos.col, col);
  const maxY = Math.max(startPos.row, row);

  for (let x = minX; x <= maxX; x++) {
    for (let y = minY; y <= maxY; y++) {
      newHighlightedCells.push({ col: x, row: y });
    }
  }

  return newHighlightedCells;
};

export const calculateSectionDimensions = (
  startPos: LayoutGridCell,
  col: number,
  row: number,
) => {
  const x = Math.min(startPos.col, col);
  const y = Math.min(startPos.row, row);
  const w = Math.abs(col - startPos.col) + 1;
  const h = Math.abs(row - startPos.row) + 1;

  return { x, y, w, h };
};

export const isAreaOccupied = (
  occupiedCells: boolean[][],
  x: number,
  y: number,
  width: number,
  height: number,
): boolean => {
  for (let dx = 0; dx < width; dx++) {
    for (let dy = 0; dy < height; dy++) {
      if (occupiedCells[y + dy]?.[x + dx]) {
        return true; // Return true if any cell is occupied
      }
    }
  }

  return false;
};
